import { FunctionComponent, memo } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { Button } from "@edgetier/components";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import ExemptionForm from "../exemption-form";
import { IProps } from "./create-spelling-exemption-button.types";
import "./create-spelling-exemption-button.scss";

/**
 * Button component, when clicked, opens the form to create a new exemption in a modal.
 */
const CreateSpellingExemptionButton: FunctionComponent<IProps> = () => {
    const { openModal, closeModal, modalProps } = useModal();
    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Create exemption</h2>
                </ModalHeader>
                <ModalContent>
                    <ExemptionForm toggleAction={closeModal} />
                </ModalContent>
            </Modal>
            <Button icon={faPlus} onClick={openModal}>
                Create exemption
            </Button>
        </>
    );
};

export default memo(CreateSpellingExemptionButton);
